import { BaseReducer } from '@identic/api';
import { MessageState, MessageInitialState, MessageActions } from './message.state';

export function MessageReducer(state: MessageState = MessageInitialState, action: any): MessageState {
  return BaseReducer(state, action, MessageActions);
}
// console.log(`%cMessageReducer::ngOnInit`, 'background:yellow');
